import { render } from "./ExternalPlatform.vue?vue&type=template&id=27e0393a&scoped=true"
import script from "./ExternalPlatform.vue?vue&type=script&lang=js"
export * from "./ExternalPlatform.vue?vue&type=script&lang=js"

import "./ExternalPlatform.vue?vue&type=style&index=0&id=27e0393a&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e0393a"]])

export default __exports__